<template>
  <v-card style="background-color: white" elevation="0">
    <div style="display: flex; flex-direction: column">
      <div style="margin-left: 20px; margin-top: 10px">
        <span style="font-size: 20px; font-weight: bold">{{
          this.$t("_alertes_and_recomendation_")
        }}</span>
      </div>
    </div>
    <div>
      <v-data-table
        :headers="headers"
        :items="items"
        style="margin: 10px"
        :footer-props="{
          'items-per-page-options': [20, 50, 100, -1],
          'items-per-page-text': this.$t('_lignes_par_page_'),
        }"
        :items-per-page="10"
        :item-key="'id'"
        :single-expand="true"
        :expanded.sync="alarmExpanded"
        show-expand
        dense
      >
        <template v-slot:item.cat_checklist="{ item }">
          <icon
            v-if="item.cat_checklist"
            :icon="getIconifyIcon(item.cat_checklist)"
            :height="item.icon_height"
            :color="'#000'"
          />
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <ul class="mx-0 my-2" style="line-height: 1.25rem">
              <li
                v-for="msg in splitBySeparator(item.message, '\n')"
                :key="msg"
              >
                {{ msg }}
              </li>
            </ul>
          </td>
        </template>

        <template v-slot:item.module="{ item }">
          <td v-for="column in headers" :key="column.value">
            <span v-if="column.value == 'module'">
              <v-btn @click="naviguateto(item)" medium icon>
                <i class="fas fa-search"></i>
              </v-btn>
            </span>
          </td>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
//import api from "@/api/api";
import { mapGetters } from "vuex";
import { Icon } from '@iconify/vue2'

export default {
  components: {
        Icon,

	},
  props: {
    selected_date: {
      type: String,
      required: true,
    },
    liste_alarmes: {
      type: Array,
      required: true
    },
    nbr_site: {
      type: Array,
      required: true,
    },
    installation_id: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      headers: [],
      items: [],
      target_links:[],
      alarmExpanded: [], // Track expanded rows
      hiddenColumns: ['validate'], // Example of hidden columns, can be dynamic
    };
  },
  computed: {
    ...mapGetters(["role", "installations", "cur_install_id", "constants"]),
  },

  watch: {
    selected_date: {
      handler() {
        this.getdata();
      },
    },
    liste_alarmes(newVal) {
      this.items = newVal.map((alarm, index) => ({
        id: index,  // Ensure each item has a unique id (or use a specific unique identifier from your data)
        message: alarm.message,
        site: alarm.site,
        cat_checklist: alarm.icon,
        checklist_desc: alarm.checklist_desc,
        icon_height:alarm.icon_height,
        criticity: alarm.criticity,
        status: alarm.status,
        open_date: alarm.open_date,
        close_date: alarm.close_date,
        pertes: alarm.pertes,
        cost: alarm.cost,
        loss_frac: alarm.loss_frac,
      }));
    },
    nbr_site: {
      handler() {
        this.getdata();
      },
    },
    "$root.$i18n.locale": {
      async handler() {
        await this.refresh_header_values()
      },
      immediate: true,
      deep: true,
    },
    '$route': {
        async handler() {
          await this.refresh_header_values()

        },
        immediate: true,
      },
  },

  methods: {
    async getdata() {

      if (this.liste_alarmes.length > 0) {
      this.items = this.liste_alarmes.map((alarm, index) => ({
        id: index,  // Ensure each item has a unique id
        message: alarm.message,
        site: alarm.site,
        cat_checklist: alarm.icon,
        checklist_desc: alarm.checklist_desc,
        icon_height:alarm.icon_height,
        criticity: alarm.criticity,
        status: alarm.status,
        open_date: alarm.open_date,
        close_date: alarm.close_date,
        pertes: alarm.pertes,
        cost: alarm.cost,
        loss_frac: alarm.loss_frac,
      }));
    }
    },

    // Handle row click event
    // handleRowClick(item) {
    //   console.log('Row clicked:', item);
    //   this.naviguateto(item);
    // },

    // Navigation Function
    naviguateto(item) {
      this.$store.dispatch("setInstallationAuditDate", {
        start_date: item['open_date'],
        end_date: item['close_date']
      });

      let category = ''
      this.target_links = JSON.parse(JSON.stringify(this.$store.getters.constants['smartguard_alarm']))

      for (let items in this.target_links) {

        for (let key in this.target_links[items]){
        if (item['checklist_desc'] === key ){
          category = this.target_links[items][key]

        }  }
      }
      let to = `/expert-mod/${this.installation_id}/${category}/site`;
      this.$store.commit("SET_CUR_INSTALL_ID", this.installation_id);
       // Open the URL in a new tab
       window.open(to, '_blank');
    },

    splitBySeparator(item, sep) {
      if (item !== undefined) {
        return item.substring(0, item.length - 1).split(sep);
      } else {
        return '';
      }
    },
    getIconifyIcon(iconString) {
      // Assuming iconString is in the format like 'iconoir:sine-wave'
      const [library, iconName] = iconString.split(':'); // Split library and icon name
      if (library === 'tabler') {
        return `tabler:${iconName}`;
      } else if (library === 'iconoir') {
        return `iconoir:${iconName}`;
      }else if (library === 'carbon') {
        return "carbon:data-blob";
      } else if (library === 'game-icons') {
      return `game-icons:${iconName}`;
    }
      else {
        return null;
      }
    },
    refresh_header_values(){
        this. headers= [
        { text: this.$t('_site_'), value: 'site' },
        { text: this.$t('_categorie_'), align: 'start', sortable: false, value: 'cat_checklist' },
        { text: this.$t('_sub_categorie_'), value: 'checklist_desc' },
        { text: this.$t('_criticite_'), value: 'criticity' },
        { text: this.$t('_statut_'), value: 'status' },
        { text: this.$t('_date_d_ouverture_'), value: 'open_date' },
        { text: this.$t('_date_de_fermeture_'), value: 'close_date' },
        { text: this.$t('_pertes_kwh_'), value: 'pertes' },
        { text: this.$t('_cout_'), value: 'cost' },
        { text: this.$t('_pertes_frac_'), value: 'loss_frac' },
        //{ text: this.$t('_lien_vers_modules_experts_'), value: 'module', width: '15%'},
      ]

    },
  },
};
</script>

<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
  font-size: 0.75rem;
  height: 45px;
  line-height: 1.2;
}
#sys_acq > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#env_res > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#inv > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#field_mod > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#alm_inc > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2) {
  height: 50px;
  vertical-align: middle;
  background-color: #f7f7f7;
}

.table-text {
  font-family: Roboto, sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  text-align: left;
}

.text-subtitle-3 {
  font-size: 0.775rem !important;
  font-weight: 500;
  line-height: 1.25rem;
  letter-spacing: 0.0071428571em !important;
  font-family: Roboto, sans-serif !important;
  color: grey;
}
</style>
